import React from 'react';
import { Section, SectionHead } from './primitives';

const ROWS = [
  {
    k: 'Trading app',
    lead: 'React front end',
    body: ' — portfolios, recommendations with reasoning, one-click order placement, live P&L, paper and live modes. Themable down to logo, palette, and copy.',
  },
  {
    k: 'Platform API',
    lead: 'FastAPI backend',
    body: ' — the full REST surface, plus MCP server and webhooks, so your own agents and services can drive the platform from inside your network.',
  },
  {
    k: 'Agent layer',
    lead: 'Research, setup, and execution agents',
    body: ' with configurable risk personas — from capital-preservation to aggressive momentum — and a composite scoring framework for ranking tokens.',
  },
  {
    k: 'Risk engine',
    lead: 'Policy-enforced sizing, leverage caps, stop-loss / take-profit / trailing orders',
    body: ', and human-in-the-loop approval that you can require, relax, or automate per user tier.',
  },
  {
    k: 'Execution',
    lead: 'Hyperliquid perpetuals integration',
    body: ' — EIP-712 signing, agent delegation, advanced order types, and your own builder code so builder fees accrue to you.',
  },
  {
    k: 'Multi-tenancy',
    lead: 'Users, plans, quotas, and metering',
    body: ' already built — run it as an internal tool for one desk, or as a subscription product for thousands of accounts.',
  },
  {
    k: 'Deployment',
    lead: 'Containers and infrastructure-as-code',
    body: ', database migrations, health checks, and a documented upgrade path from one release to the next.',
  },
  {
    k: 'Documentation',
    lead: 'Operator and developer docs',
    body: ', API reference, integration guides, and prompt/persona packs you can fork and tune.',
  },
  {
    k: 'Support',
    lead: 'Onboarding, a private support channel, and release updates',
    body: ' for the term of the license. Scope and response targets are set in your agreement.',
  },
];

export const IncludedTable = () => (
  <Section id="included">
    <SectionHead eyebrow="What you get" title="The whole platform, not a demo." />
    <div className="grid overflow-hidden rounded-xl border border-gray-700/60">
      {ROWS.map((row) => (
        <div
          key={row.k}
          className="grid gap-2 border-t border-gray-700/60 bg-gray-800/40 px-6 py-5 first:border-t-0 sm:grid-cols-[190px_1fr] sm:gap-6"
        >
          <div className="pt-0.5 font-mono text-[0.8rem] tracking-[0.04em] text-cyan-400">
            {row.k}
          </div>
          <div className="text-[0.95rem] text-gray-400">
            <strong className="font-semibold text-white">{row.lead}</strong>
            {row.body}
          </div>
        </div>
      ))}
    </div>
  </Section>
);

export default IncludedTable;
